import { isAxiosError } from 'axios';

export const isAxiosNetworkOrTimeout = (error: unknown): boolean => {
  if (!isAxiosError(error)) return false;
  if (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK')
    return true;
  return !error.response;
};
